import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { GET, POST, PUT } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";
import { ClearSelectedBank } from "../wallet/slice";
import { socket } from "../../utils/socket";

// Auth - Login
export const AuthLogin = createAsyncThunk(
  "auth/login/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.Login, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("moneyking_web_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log(" Token saved in cookies:", res.data.token);

      } else {
        console.warn(" No token found in login response");
      }
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const AuthSignUp = createAsyncThunk(
  "auth/signIn/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.SignIn, data);

      if (res?.success && res?.data?.token) {
        Cookies.set("moneyking_web_security", res.data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        console.log(" Token saved in cookies:", res.data.token);
      } else {
        console.warn(" No token found in login response");
      }
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const SendOTP = createAsyncThunk(
  "auth/SendOTP/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.OtpSend, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const SendEmailOTP = createAsyncThunk(
  "auth/SendEmailOTP/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.OtpEmailSend, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const VerifyOTP = createAsyncThunk(
  "auth/VerifyOTP/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.OtpVerify, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const AuthForgotPassword = createAsyncThunk(
  "auth/AuthForgotPassword/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.ForgotPass, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const AuthChangePassword = createAsyncThunk(
  "auth/AuthChangePassword/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await PUT(APIS.Auth.ChangePassword, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const AuthUpdate = createAsyncThunk(
  "auth/AuthUpdate/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.Update_User, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const SubmitFeedback = createAsyncThunk(
  "auth/SubmitFeedback/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Auth.SubmitFeedback, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



// GET Auth - Login
export const GETAuthLogin = createAsyncThunk(
  "auth/login/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Auth.Get_User);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const dashboard = createAsyncThunk(
  "dashbord/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Dashboard);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const AuthLogOut = createAsyncThunk(
  // Auth - Logout
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      // const res = await GET(APIS.Auth);
      Cookies.remove("moneyking_web_security", { path: "/" });
      // Cookies.remove("moneyking_remember", { path: "/" });
      socket.disconnect();

      ClearSelectedBank()
      return {
        data: {},
        token: null,
        role: null,
        permissions: null,
        isLogin: false,
        error: null,
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const GETVipLevel = createAsyncThunk(
  "auth/login/get-level",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Auth.GETVipLevel);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GETAllVipLevel = createAsyncThunk(
  "auth/login/get-levels",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Auth.GETVipLevel}-level`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const GETVipBenifits = createAsyncThunk(
  "auth/login/GETVipBenifits",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Auth.GETVipLevel}-benefit`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const ClaimVipBenefit = createAsyncThunk(
  "auth/ClaimVipBenefit/post",
  async (data, { rejectWithValue }) => {
    try {

      const res = await POST(`${APIS.Auth.GETVipLevel}-claim`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const GETVipBenifitHistory = createAsyncThunk(
  "auth/login/GETVipBenifitHistory",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Auth.GETVipLevel}-history?page=${filter?.page || 1}&per_page=${filter?.per_page || 10}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const receiveGiftCode = createAsyncThunk(
  "auth/receiveGiftCode/post",
  async (data, { rejectWithValue }) => {
    try {

      const res = await POST(`${APIS.Gifts.Giftcode}`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const getGiftHistory = createAsyncThunk(
  "auth/login/getGiftHistory ",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Gifts.Giftcode}?page=${filter?.page || 1}&per_page=${filter?.per_page || 10}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const Slice = createSlice({
  name: "auth",
  initialState: {
    data: {},
    VipData: {},
    VipLevels: [],
    VipBenefits: [],
    GiftHistory: [],
    token: null,
    role: null,
    permissions: null,
    isLogin: false,
    status: IDS.SLICESTATUS.Idle,
    error: null,
    all_permission: {},
    all_dashboard: {},
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(AuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogin.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.token = action.payload?.data?.token;
        state.role = action.payload?.data?.role;
        state.permissions = action.payload?.data?.permissions;
        state.isLogin = true;
      })
      .addCase(AuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(GETVipLevel.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETVipLevel.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.VipData = action.payload.data;

      })
      .addCase(GETVipLevel.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.VipData = {};

      })

      .addCase(GETVipBenifits.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETVipBenifits.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.VipBenefits = action.payload.data;

      })
      .addCase(GETVipBenifits.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.VipData = {};
      })

      .addCase(GETVipBenifitHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETVipBenifitHistory.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;

      })
      .addCase(GETVipBenifitHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.VipData = {};
      })
      .addCase(getGiftHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getGiftHistory.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.GiftHistory = action.payload.data;

      })
      .addCase(getGiftHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.VipData = {};
      })

      .addCase(GETAllVipLevel.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETAllVipLevel.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.VipLevels = action.payload.data;

      })
      .addCase(GETAllVipLevel.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.VipData = {};
      })

      .addCase(GETAuthLogin.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETAuthLogin.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
        state.role = action.payload.data.role;
        state.permissions = action.payload.data.permissions;
        state.isLogin = true;
      })
      .addCase(GETAuthLogin.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        // state.isLogin = false;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      //
      .addCase(AuthLogOut.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AuthLogOut.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = {};
        state.token = null;
        state.role = null;
        state.permissions = null;
        state.isLogin = false;
      })
      .addCase(AuthLogOut.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })

      .addCase(dashboard.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;


        state.all_dashboard = action.payload?.data;

      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.isLogin = false;
      })



  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
